import { PolicyCategory } from "../../entities/projectPolicy";
import { decodeProjectPolicyQuestion, encodeProjectPolicyQuestion } from "../projectPolicyQuestion";
export const decodeProjectPolicy = (projectPolicy) => {
    return {
        created: new Date(projectPolicy.created),
        frequency: projectPolicy.frequency,
        generationSource: projectPolicy.generation_source,
        id: projectPolicy.project_policy_id,
        isForm: projectPolicy.is_form ?? false,
        isProjectLevelPolicy: projectPolicy.is_project_level_policy,
        policyCategory: projectPolicy.policy_category ?? PolicyCategory.Document,
        policyDescription: projectPolicy.policy_description,
        policyType: projectPolicy.policy_type,
        projectId: projectPolicy.project_id,
        questions: (projectPolicy.questions ?? []).map((q) => decodeProjectPolicyQuestion(q)),
        registerSubject: projectPolicy.register_subject,
        sourceFrameworkId: projectPolicy.source_framework_id,
        sourceFrameworkTargetId: projectPolicy.source_framework_target_id,
        uri: projectPolicy.uri
    };
};
export const encodeProjectPolicy = (projectPolicy) => {
    return {
        created: projectPolicy.created,
        frequency: projectPolicy.frequency,
        generation_source: projectPolicy.generationSource,
        is_form: projectPolicy.isForm,
        is_project_level_policy: projectPolicy.isProjectLevelPolicy,
        policy_category: projectPolicy.policyCategory,
        policy_description: projectPolicy.policyDescription,
        policy_type: projectPolicy.policyType,
        project_id: projectPolicy.projectId,
        project_policy_id: projectPolicy.id,
        questions: projectPolicy.questions.map((q) => encodeProjectPolicyQuestion(q)),
        register_subject: projectPolicy.registerSubject,
        source_framework_id: projectPolicy.sourceFrameworkId,
        source_framework_target_id: projectPolicy.sourceFrameworkTargetId,
        uri: projectPolicy.uri
    };
};
